import { render, staticRenderFns } from "./western.vue?vue&type=template&id=50d7eb49&scoped=true&"
import script from "./western.vue?vue&type=script&lang=js&"
export * from "./western.vue?vue&type=script&lang=js&"
import style0 from "./western.vue?vue&type=style&index=0&id=50d7eb49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7eb49",
  null
  
)

export default component.exports